
import axios from "axios";
import { ApiErrorResponse } from "../DTO/ApiResponseError";

export function globalApiError(error: unknown): string {

  if (!axios.isAxiosError<ApiErrorResponse>(error)) {
    return "Ha ocurrido un error inesperado.";
  }

  if (!error.response) {
    return "No se ha podido conectar con el servidor.";
  }


  const apiError = error.response.data;

  if (apiError?.fieldErrors) {
    const messages = Object.values(apiError.fieldErrors);

    if (messages.length > 0) {
      return messages.join(", ");
    }

  }

   if (error.response.status === 401) {
    return "Tu sesión no es válida o las credenciales son incorrectas.";
  }

  if (error.response.status === 403) {
    return "No tienes permisos para realizar esta acción.";
  }

  return apiError?.message || "Ha ocurrido un error inesperado.";
}